import axios from 'axios';
import { format } from 'date-fns';
import { BASE_URL } from 'store/baseConfig';
import { getCookie } from 'utils/utilsCookies';
import axiosInstance from './axiosInstance';

// -----------------------------------------------
// Common
// -----------------------------------------------
export const loginAPI = async (data) => {
    const { username, password } = data
    const url = '/login/'
    const urldata = {
        'username': username,
        'password': password
    }

    const resp = await axiosInstance.post(url, urldata)
    return resp
};

export const logoutAPI = async (refreshToken, token) => {
    const url = `/logout/`
    const headers = {
        'Authorization': `Bearer ${token}`,
        'X-CSRFToken': getCookie('csrftoken'),
    }

    try {
        const resp = await axios.post(url, { refresh: refreshToken }, { headers: headers, withCredentials: true, baseURL: BASE_URL })
        return resp
    } catch (error) {
        throw error;
    }
};

export const refreshTokenAPI = async (refreshToken, token) => {
    const url = '/token/refresh/'
    const headers = {
        'X-CSRFToken': getCookie('csrftoken'),
        'Authorization': `Bearer ${token}`
    }
    const resp = await axios.post(url, { refresh: refreshToken }, { headers: headers, withCredentials: true, baseURL: BASE_URL })
    return resp
};

export const getCodeList = async (code_list) => {
    /**
     * 코드 목록 반환
     */
    const url = '/common/code';
    try {
        const resp = await axiosInstance.get(url, { params: { code_list: JSON.stringify(code_list) } }); // code_list를 JSON 문자열로 변환하여 전달
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getEmployeeSalaryList = async (employeeNo, filter) => {
    const url = `/common/view-salary/${employeeNo}`;
    try {
        const resp = await axiosInstance.get(url, { params: filter });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}


export const getEmployeeWorkTimeFormat = async (employeeNo, workYM) => {
    const url = `/common/view-work-time-format/${employeeNo}`;
    try {
        const resp = await axiosInstance.get(url, { params: { workYM: workYM } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getEmployeeWorkTimeFormatList = async (workYM) => {
    const url = `/common/view-work-time-format`;
    try {
        const resp = await axiosInstance.get(url, { params: { workYM: workYM } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }

}
export const getInsuranceRate = async () => {
    /**
     * 보험 공제율 조회
     */
    const url = 'common/insurance-rate';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getCrtlwhTime = async (startTime, endTime) => {
    const url = `/common/crtlwh`;
    try {
        const resp = await axiosInstance.get(url, { params: { startTime: startTime, endTime: endTime } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}


// -----------------------------------------------
// Management
// -----------------------------------------------
export const getCompanyList = async () => {
    /**
     * 회사 목록 반환
     */
    const url = '/management/corporations';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getCompany = async (corp_no) => {
    /**
     * 회사 조회
     */
    const url = `/management/corporation/${corp_no}`;
    try {
        const resp = await axiosInstance.get(url); // 헤더 추가
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const postCompanyCreate = async (apiData) => {
    /**
     * 회사 생성 
     * src\pages\management\company-info\ManagementCompanyAdd.js
     */
    const url = '/management/corporations';

    const headers = {
        'Content-Type': 'multipart/form-data'
    };

    try {
        const resp = await axiosInstance.post(url, apiData, { headers: headers }); // 헤더 추가
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getBasicGrpList = async () => {
    /**
     * 기초 그룹 목록 반환
     */
    const url = '/management/basic-info';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getBasicPositionList = async (grp_no) => {
    /**
     * 기초 직위 목록 반환
     */
    let url = '/management/basic-info/company-info/position';
    if (grp_no) url = `${url}/${grp_no}`;

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getBasicDepartmentList = async (grp_no) => {
    /**
     * 기초 부서 목록 반환
     */
    let url = '/management/basic-info/company-info/department';
    if (grp_no) url = `${url}/${grp_no}`;

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getBasicInsuranceList = async () => {
    /**
     * 기초 보험 목록 반환
     */
    const url = '/management/basic-info/insurance';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getBasicTaxList = async () => {
    /**
     * 기초 소득세율 목록 반환
     */
    const url = '/management/basic-info/tax';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getBasicSimpleTaxList = async () => {
    /**
     * 기초 간이세액표 목록 반환
     */
    const url = '/management/basic-info/simple-tax';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getBasicAttendanceList = async () => {
    /**
     * 기초 근태 목록 반환
     */
    const url = '/management/basic-info/attendance';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getBasicSalaryList = async () => {
    /**
     * 기초 급여 목록 반환
     */
    const url = '/management/basic-info/salary';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getBasicHolidayList = async () => {
    /**
     * 기초 공휴일 목록 반환
     */
    const url = '/management/basic-info/holiday';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};


export const getManagerList = async () => {
    /**
     * 관리자 목록 반환
     */
    const url = '/management/manager';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

// -----------------------------------------------
// Basic Info ( 회사 기초 정보 )
// -----------------------------------------------
export const getBasicInsuranceApplyList = async () => {
    /**
     * 기초 보험 적용 목록 반환
     */
    const url = '/basic-info/insurance';

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
};

export const getCompanyDepartmentList = async (corp_no) => {
    /**
     * 회사 부서 목록 반환
     */
    const url = '/basic-info/company-info/department';

    try {
        const resp = await axiosInstance.get(url, { params: { corp_no: corp_no } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const postCompanyDepartmentList = async (apiData) => {
    /**
     * 회사 부서 목록 생성
     */
    const url = '/basic-info/company-info/department';

    try {
        const resp = await axiosInstance.post(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }

}

export const putCompanyDepartmentList = async (apiData) => {
    /**
     * 회사 부서 목록 수정
     */
    const url = '/basic-info/company-info/department';

    try {
        const resp = await axiosInstance.put(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const deleteCompanyDepartmentList = async (apiData) => {
    /**
     * 회사 부서 목록 삭제
     */
    const url = `/basic-info/company-info/department`;

    try {
        const resp = await axiosInstance.delete(url, { data: apiData });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }

}

export const getCompanyPositionList = async (corp_no) => {
    /**
     * 회사 직위 목록 반환
     */
    const url = '/basic-info/company-info/position';

    try {
        const resp = await axiosInstance.get(url, { params: { corp_no: corp_no } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const postCompanyPositionList = async (apiData) => {
    /**
     * 회사 직위 목록 생성
     */
    const url = '/basic-info/company-info/position';

    try {
        const resp = await axiosInstance.post(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const putCompanyPositionList = async (apiData) => {
    /**
     * 회사 직위 목록 수정
     */
    const url = '/basic-info/company-info/position';

    try {
        const resp = await axiosInstance.put(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const deleteCompanyPositionList = async (apiData) => {
    /**
     * 회사 직위 목록 삭제
     */
    const url = `/basic-info/company-info/position`;

    try {
        const resp = await axiosInstance.delete(url, { data: apiData });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}



export const getCompanyAttendanceList = async (corp_no, type) => {
    /**
     * 회사 근태 목록 반환
     */
    const url = '/basic-info/attendance';

    try {
        const resp = await axiosInstance.get(url, { params: { corp_no: corp_no, type: type } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const putCompanyAttendanceList = async (apiData) => {
    /**
     * 회사 근태 목록 수정
     */
    const url = '/basic-info/attendance';

    try {
        const resp = await axiosInstance.put(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getCompanySalaryList = async (corp_no, filter) => {
    /**
     * 회사 급여 목록 반환
     */
    const url = '/basic-info/salary';

    try {
        const resp = await axiosInstance.get(url, { params: { corp_no: corp_no, filter: filter } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const postCompanySalaryList = async (apiData) => {
    /**
     * 회사 급여 목록 생성
     */
    const url = '/basic-info/salary';

    try {
        const resp = await axiosInstance.post(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const putCompanySalaryList = async (apiData) => {
    /**
     * 회사 급여 목록 수정
     */
    const url = '/basic-info/salary';

    try {
        const resp = await axiosInstance.put(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const deleteCompanySalaryList = async (apiData) => {
    /**
     * 회사 급여 목록 삭제
     */
    const url = `/basic-info/salary`;

    try {
        const resp = await axiosInstance.delete(url, { data: apiData });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getCompanyHolidayList = async (corp_no) => {
    /**
     * 회사 공휴일 목록 반환
     */
    const url = '/basic-info/holiday';

    try {
        const resp = await axiosInstance.get(url, { params: { corp_no: corp_no } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}


export const postCompanyHolidayList = async (apiData) => {
    /**
     * 회사 공휴일 목록 생성
     */
    const url = '/basic-info/holiday';

    try {
        const resp = await axiosInstance.post(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const putCompanyHolidayList = async (apiData) => {
    /**
     * 회사 공휴일 목록 수정
     */
    const url = '/basic-info/holiday';

    try {
        const resp = await axiosInstance.put(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const deleteCompanyHolidayList = async (apiData) => {
    /**
     * 회사 공휴일 목록 삭제
     */
    const url = '/basic-info/holiday';

    try {
        const resp = await axiosInstance.delete(url, { data: apiData });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

// -----------------------------------------------
// HRM
// -----------------------------------------------
export const getEmployeeList = async (filterData) => {
    /**
     * 사원 목록 반환
     */
    let url = '/hrm/employees?';

    try {
        const resp = await axiosInstance.get(url, { params: filterData });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const postEmployeeCreate = async (apiData, empl_no) => {
    /**
     * 사원 생성
     */
    let url = '/hrm/employees';
    if (empl_no) {
        url = `/hrm/employee/${empl_no}`;
    }

    const headers = {
        'Content-Type': 'multipart/form-data'
    };

    try {
        const resp = await axiosInstance.post(url, apiData, { headers: headers });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getEmployee = async (empl_no) => {
    /**
     * 사원 조회
     */
    const url = `/hrm/employee/${empl_no}`;

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

// -----------------------------------------------
// Attendance
// -----------------------------------------------
export const getAttendanceTag = async (atend_no) => {
    /**
     * 근태 태그 조회
     */
    let url = '/attendance/work-time';
    if (atend_no) {
        url = `${url}/${atend_no}`;
    }

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const postAttendanceTag = async (apiData) => {
    /**
     * 근태 태그 생성
     */
    const url = '/attendance/work-times';

    try {
        const resp = await axiosInstance.post(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getAttendanceTagList = async (filterData) => {
    /**
     * 근태 태그 목록 반환
     */
    const url = '/attendance/work-times';

    try {
        const resp = await axiosInstance.get(url, { params: filterData });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getAttendanceDailyWorks = async (filterData) => {
    /**
     * 사원 일별 근태 조회 - 리스트
     * TODO: 사원 번호, 회사 번호, 부서 번호 등으로 조회 조건 추가
     */
    const url = `attendance/daily-works`;

    try {
        const resp = await axiosInstance.get(url, { params: filterData });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getAttendanceDailyWork = async (empl_no, workDate) => {
    /**
     * 사원 일별 근태 조회 - 1건
     */
    const url = `attendance/daily-work/${empl_no}`;

    try {
        const resp = await axiosInstance.get(url, { params: { workDate: workDate } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getAttendanceManagement = async (month, userNo) => {
    /**
     * 근태 관리 조회
     */
    const url = '/attendance/management';

    try {
        const resp = await axiosInstance.get(url, { params: { month: month, userNo: userNo } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const postAttendanceManagement = async (month, userNo) => {
    /**
     * 근태 관리 초기 생성
     */
    const url = '/attendance/management';

    try {
        const resp = await axiosInstance.post(url, { month: month, userNo: userNo });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const putAttendanceManagement = async (apiData) => {
    /**
     * 사원 일별 근태 관리 수정
     */
    const url = `/attendance/management`;

    try {
        const resp = await axiosInstance.put(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getCalTime = async (empl_no, workDate, atendTime, lvofcTime, gnot, rtn, workSch) => {
    /**
     * 근태 관리 계산
     */

    const url = `attendance/management/recalculation/${empl_no}`;
    try {
        const resp = await axiosInstance.get(url, {
            params: {
                workDate: workDate, atendTime: atendTime, lvofcTime: lvofcTime, gnot: gnot, rtn: rtn, workSch: workSch
            }
        });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const postAttendanceDailyWork = async (empl_no, formData) => {
    /**
     * 근태 관리 조회
     * TODO: getAttendanceDailyWorks 로 대체하기
     */
    const url = `attendance/daily-work/${empl_no}`;

    const apiData = {
        ...formData
    }

    try {
        const resp = await axiosInstance.post(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}
// -----------------------------------------------
// Salary
// -----------------------------------------------
export const getSalaryManagement = async (filter) => {
    /**
     * 급여 관리 조회
     */
    const url = '/salary/management';

    try {
        const resp = await axiosInstance.get(url, { params: filter });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const postSalaryManagement = async (apiData) => {
    /**
     * 급여 관리 생성
     */
    const url = '/salary/management';

    // const apiData = {
    //     month: month,
    //     employeeNo: employeeNo
    // }

    try {
        const resp = await axiosInstance.post(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const putSalaryManagement = async (apiData) => {
    /**
     * 급여 관리 수정
     */
    const url = '/salary/management';

    try {
        const resp = await axiosInstance.put(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getPaymentList = async (month, companyNo, employeeNos, paymentType) => {
    /**
     * 급여 내역 조회
     */
    const url = '/salary/payment';

    try {
        const resp = await axiosInstance.get(url, { params: { month: month, companyNo: companyNo, employeeNos: employeeNos, paymentType: paymentType } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getPaymentYearList = async (year, paymentType) => {
    /**
     * 급여 내역 조회
     */
    const url = '/salary/payment-year-list';

    try {
        const resp = await axiosInstance.get(url, { params: { year: year, paymentType: paymentType } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getTransferList = async (yearMonth, paymentType) => {
    /**
     * 급여 내역 조회
     */
    const url = '/salary/transfer';

    try {
        const resp = await axiosInstance.get(url, { params: { yearMonth: yearMonth, paymentType: paymentType } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getLeavePaymentList = async (year, paymentType) => {
    /**
     * 급여 내역 조회
     */
    const url = 'salary/leave/payment-list';

    try {
        const resp = await axiosInstance.get(url, { params: { year: year, paymentType: paymentType } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getCalcEncpnd = async (type, encpnd, calcDate) => {
    const url = '/common/tests';

    try {
        console.log(type, encpnd, calcDate);
        const formattedEncpnd = format(encpnd, 'yyyy-MM-dd');
        const formattedCalcDate = format(calcDate, 'yyyy-MM-dd');
        const resp = await axiosInstance.get(url, { params: { type: type, encpnd: formattedEncpnd, calcDate: formattedCalcDate } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getRetirementPensionList = async (yearMonth) => {
    /**
     * 퇴직연금 내역 조회
     */
    const url = '/salary/retirement-pension';

    try {
        const resp = await axiosInstance.get(url, { params: { yearMonth: yearMonth } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getDepartureList = async (yearMonth) => {
    /**
     * 퇴직연금 내역 조회
     */
    const url = '/salary/departure';

    try {
        const resp = await axiosInstance.get(url, { params: { yearMonth: yearMonth } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }

}


export const getSalaryLeaveList = async (year) => {
    /**
     * 연차 목록 조회
     */
    const url = '/salary/leave';

    try {
        const resp = await axiosInstance.get(url, { params: { year: year } });
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}


export const postESystemForm = async (apiData) => {
    /**
     * 전자결재 기안 생성
     */
    const url = '/e-system/form';

    try {
        const resp = await axiosInstance.post(url, apiData);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getESystemList = async (pageType) => {
    /**
     * 전자결재 목록 조회
     */
    const url = `/e-system/list/${pageType}`;

    try {
        const resp = await axiosInstance.get(url);
        return resp.data;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const getBeaconList = async (corp_no) => {
    /**
     * 비콘 내역 조회
     */
    const url = '/terminal/beacon';

    try {
        const resp = await axiosInstance.get(url, { params: { corp_no: corp_no } });
        return resp;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }

}

export const getBeaconDetail = async (companyNo) => {
    /**
     * 비콘 내역 조회
     */
    const url = `/terminal/beacon/detail/${companyNo}`;  // companyNo를 경로에 포함

    try {
        const resp = await axiosInstance.get(url);  // 쿼리 파라미터 대신 URL 경로에 companyNo 값을 전달
        return resp;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }
}

export const postBeaconInsert = async (beaconData) => {
    /**
     * 비콘 등록
     */
    const url = '/terminal/beacon/write';
    
    try {
        const resp = await axiosInstance.post(url, beaconData);
        return resp;
    } catch (error) {
        return Promise.reject(error);
    }
}

export const getBeaconDetailByName = async (no) => {
    const url = `/terminal/beacon/modify/${no}`;
    
    try {
        const resp = await axiosInstance.get(url);
        return resp;
    } catch (error) {
        return Promise.reject(error);
    }
}

export const postupdateBeacon = async (beaconData) => {
    const url = '/terminal/beacon/modifydata';
    
    try {
        const resp = await axiosInstance.post(url, beaconData);
        return resp;
    } catch (error) {
        return Promise.reject(error);
    }
}

export const postdeleteBeacon = async (no) => {
    const url = `/terminal/beacon/modifydelete/${no}`;
    
    try {
        const resp = await axiosInstance.delete(url);
        return resp;
    } catch (error) {
        return Promise.reject(error);
    }
}

export const getMobileList = async (companyNo) => {
    /**
     * 비콘 내역 조회
     */
    const url = `/terminal/mobile/${companyNo}`;

    try {
        const resp = await axiosInstance.get(url);
        return resp;
    } catch (error) {
        return Promise.reject(error); // 오류 발생 시 reject
    }

}

export const getMobileDetailByName = async (no) => {
    const url = `/terminal/mobile/modify/${no}`;
    
    try {
        const resp = await axiosInstance.get(url);
        return resp;
    } catch (error) {
        return Promise.reject(error);
    }
}

export const postdeleteMobile = async (no) => {
    const url = `/terminal/mobile/modifydelete/${no}`;
    
    try {
        const resp = await axiosInstance.delete(url);
        return resp;
    } catch (error) {
        return Promise.reject(error);
    }
}